import { Check, Clock } from 'lucide-react';

interface PaymentHeaderProps {
    amount: string;
    date: string;
    reference: string;
    /** True once the bill is actually paid — drives the check/label vs. pending. */
    isPaid?: boolean;
}

export default function PaymentHeader({ amount, date, reference, isPaid = false }: PaymentHeaderProps) {
    // Only claim "Amount Paid" when the bill really is paid; otherwise show a
    // neutral pending state so the header never contradicts the status badge.
    return (
        <div className="text-center mb-8">
            <div
                className={`flex items-center justify-center gap-2 mb-2 ${
                    isPaid ? 'text-green-600' : 'text-amber-600'
                }`}
            >
                {isPaid ? <Check className="w-5 h-5" /> : <Clock className="w-5 h-5" />}
                <span className="text-gray-600">{isPaid ? 'Amount Paid' : 'Amount Due'}</span>
            </div>
            <h1 className="text-4xl font-bold text-[#3A3A3A] mb-2">{amount}</h1>
            <p className="text-gray-600">{date} • Ref: {reference}</p>
        </div>
    )
}
